module.exports = __webpack_public_path__ + "img/welcome.b6f1cdb7.jpg";